export function calculateCoordinate (count: number, r: number, cx: number, cy: number, sa?: number ) {
  const sectors = [];
  let startAngle = sa ?? 0;
  let endAngle = 0;
  let maxCard = 100;
  for (let i=0; i<count; i++)  {
    if (i<=maxCard-1){
      const angle = 360/count;
      endAngle += angle;
      const rad = Math.PI / 180;
      const x = cx + r * Math.cos(startAngle * rad);
      const y = cy + r * Math.sin(startAngle * rad);
      startAngle += angle;
      const deg = startAngle;
      sectors.push({x, y, deg});
    } else {
      const angle = 360/(count-maxCard);
      endAngle += angle;
      const rad = Math.PI / 180;
      const x = cx + r * 2 * Math.cos(startAngle * rad);
      const y = cy + r * 2 * Math.sin(startAngle * rad);
      startAngle += angle;
      const deg = startAngle;
      sectors.push({x, y, deg});
    }
  }
  return sectors;
}
